/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FamiliesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Remove a person from a family
     * @returns void
     * @throws ApiError
     */
    public deletePersonFromFamily({
        family,
        person,
    }: {
        /**
         * Family ID
         */
        family: number,
        /**
         * Person ID
         */
        person: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/families/{family}/person/{person}',
            path: {
                'family': family,
                'person': person,
            },
            errors: {
                403: `Forbidden`,
                404: `Family or person not found`,
                422: `Person is not a member of this family`,
            },
        });
    }

}
